module.exports = __webpack_public_path__ + "static/media/biro-conciliacao.750da30b.jpg";